const config: any = {
  closuresList: [],
  closuresLoaded: false,
  loadingClosures: false,
  deletingClosures: false,
  prompts: [],
  promptsLoaded: false,
  loadingPrompts: false,
  queues: [],
  queuesLoaded: false,
  numbers: [],
  numbersLoaded: false,
  timezones: [],
  timezonesLoaded: false,
  error: '',
  message: '',
};

export default config;
